import React, { useEffect, useState, useMemo } from 'react';

import { getCountries } from 'react-phone-number-input';
import en from 'react-phone-number-input/locale/en.json';

import { useNavigate } from 'react-router-dom';
import './ModiFyRegistrationDetails.css';
import Form from 'react-bootstrap/Form';
import InfoPopover from '../Common/InfoPopover';
import ProjectsService from '../../Services/ProjectsService';
import SRQService from '../../Services/SRQService';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import ServiceRequestModel from './ServiceRequestModel';
import OtpInputModal from '../Company/OtpInputModal';

const customstyles = {
  dropdownindicator: base => ({
    ...base,
    fill: 'red',
  }),
};

function MyVerticallyCenteredModal({ show, onHide, responseMessage, onConfirm }) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      animation={false}
      backdrop='static'
      keyboard={false}
      dialogClassName='my-modal'
    >
      <Modal.Header className='modal-header'>
        <Modal.Title id="contained-modal-title-vcenter">
          Confirmation on service request
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className='modal-body'>
        <p>{responseMessage}</p>
      </Modal.Body>
      <Modal.Footer>
        <button className="ui button comm-button-style primary" onClick={onConfirm}>OK</button>
      </Modal.Footer>
    </Modal>
  );
}

const ModiFyRegistrationDetails = ({ onCancel }) => {
  const navigate = useNavigate();
  const [responseMessage, setResponseMessage] = useState('');
  const [modalShow, setModalShow] = useState(false);
  const [otpAction, setOtpAction] = useState('');
  const [OtpModalOpen, setOtpModalOpen] = useState(false);
  const [OtpDataFromModal, setOtpDataFromModal] = useState([]);
  const [isCreateSRQButtonActive, setIsCreateSRQButtonActive] = useState(false);

  const [selectedRequestTypeCompany, setSelectedRequestTypeCompany] = useState('');
  const [existingCompany, setExistingCompany] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);

  const [companyData, setCompanyData] = useState({ name: '', countryCode: '', registrationCode: '', description: '', additionalDetails: '' });
  const [editForm, setEditForm] = useState(false);
  const [editMode, setEditMode] = useState({ name: true, countryCode: true, registrationCode: true, description: true, additionalDetails: true });

  
  const countries = useMemo(
    () =>
      getCountries().sort((a, b) =>
        en[a].localeCompare(en[b])
      ),
    []
  );

  const sanitizeText = (text) => text?.replace(/(?:\r\n|\r|\n)/g, ' ') || '';

  const clearAllFields = () => {
    setSelectedRequestTypeCompany('');
    setSelectedCompany(null);
    setCompanyData({ name: '', countryCode: '', registrationCode: '', description: '', additionalDetails: '' });
    setEditForm(false);
    setEditMode({ name: true, countryCode: true, registrationCode: true, description: true, additionalDetails: true });
  };


  const handleSelectChange = (event) => {
    const eValue = event.target.value;

    if (!eValue) {
      clearAllFields();
      return;
    }


    setSelectedRequestTypeCompany(eValue);
    const company = existingCompany.find((record) => String(record.id) === String(eValue));

    if (company) {
      setSelectedCompany(company);
      setCompanyData({
        name: company.name || '',
        countryCode: company.countryCode || '',
        registrationCode: company.registrationCode || '',
        description: company.description || '',
        additionalDetails: '',
      });
      setEditForm(true);
      // Previous behaviour: automatically allow editing of Additional Details
      setEditMode({ name: true, countryCode: true, registrationCode: true, description: true, additionalDetails: false });
    }
  };

  const enableEditField = (field) => {
    // Previous behaviour also enabled the Additional Details field
    // whenever any field was put into edit mode.
    setEditMode((prev) => ({ ...prev, [field]: false, additionalDetails: false }));
  };

  const undoField = (field, value) => {
    setCompanyData((prev) => ({ ...prev, [field]: value }));
    setEditMode((prev) => ({ ...prev, [field]: true }));
  };

  const onServiceRequestCreated = () => {
    clearAllFields();
    setModalShow(false);
    navigate('/viewserviceRequests');
  };

  const handleOtp = (OtpDataToProject) => {
    setOtpDataFromModal(OtpDataToProject);
  };

  const verifyOtp = async (otpArray) => {
    if (!otpArray || otpArray.length === 0) {
      return;
    }

    const otpValue = Number(otpArray.join(''));
    ServiceRequestModel.companyId = selectedRequestTypeCompany;
    ServiceRequestModel.requestType = 'ModifyCompany';
    ServiceRequestModel.requestText = sanitizeText(companyData.additionalDetails);
    ServiceRequestModel.subjectCompany.name = companyData.name;
    ServiceRequestModel.subjectCompany.countryCode = companyData.countryCode;
    ServiceRequestModel.subjectCompany.registrationCode = companyData.registrationCode;
    ServiceRequestModel.subjectCompany.description = sanitizeText(companyData.description);

    try {
      const response = await SRQService.createNewServiceRequest(ServiceRequestModel, otpValue);
      setResponseMessage(response.data.message);
      setOtpModalOpen(false);
      setModalShow(true);
    } catch (error) {
      if (error.response?.data?.code?.startsWith('APIM-')) {
        console.log('APIM error, letting global interceptor handle it');
      } else {
        toast.error(error.response?.data?.message || 'Failed to create service request');
      }
      console.log(error);
    }
  };

  const handleClearCompanySelection = () => {
    clearAllFields();
  };

  const handleInputChange = (field) => (event) => {
    setCompanyData((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const createSRQ = async () => {
    setIsCreateSRQButtonActive(true);
    const action = 'registerCompany';
    setOtpAction(action);

    try {
      await ProjectsService.getStrongConfirmationCode('POST', null, action, null, null, null);
      setOtpModalOpen(true);
    } catch (error) {
      console.log(error);
      setIsCreateSRQButtonActive(false);
    }
  };

  const resendOtp = async () => {
    try {
      await ProjectsService.getStrongConfirmationCode('POST', null, otpAction || 'registerCompany', null, null, null);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancel = () => {
    clearAllFields();

    if (onCancel) {
      onCancel();
    }
  }

  useEffect(() => {
    const loadProjects = async () => {
      try {
        const response = await ProjectsService.getAllProjects();
        setExistingCompany(response.data[0]?.companyProjects || []);
      } catch (error) {
        console.log(error);
      }
    };

    loadProjects();
  }, []);

  const canSubmit = !isCreateSRQButtonActive && companyData.name && companyData.countryCode && companyData.registrationCode && companyData.additionalDetails && companyData.description;

  return (
    <>
      <li>
        <div className="sec">
          <div className="head-titlw-w head-titl-unset">
            <h3 className="sec-title" id="ManageCompany-ModifyCompany-promptForModifyCompany" data-info="" >
              Modify Registration Details
            </h3>
          </div>
          <ul className="serv-req sec-inner-wrap">
            {/*SELECT A COMPANY*/}
            <li>
              <div className="dropdown-w-info mt-3" id="selectModifyCompanyWrapper" style={{ display: "flex" }}>
                {selectedRequestTypeCompany ? (
                  <span id='clear-icon-ModifyRegDet-company' className="clear-icon-ModifyRegDet-company no-ligatures" onClick={handleClearCompanySelection}>
                    &times;
                  </span>
                ) : (
                  <i className="dropdown icon" />
                )}
                <div className="width-full">
                  <Form.Select defaultValue="" value={selectedRequestTypeCompany} onChange={handleSelectChange} styles={customstyles}
                    style={{ width: "100%" }}
                    className={selectedRequestTypeCompany ? 'dropdown-with-close' : 'dropdown-default'}
                  >
                    <option value="" className="textdefault">
                      Select Existing Company
                    </option>
                    {existingCompany && existingCompany.map((cp) => {
                      return <option value={cp.id}>{cp.name}</option>;
                    })
                    }
                  </Form.Select>
                </div>
                <InfoPopover
                  id="infoPopOverModifyCompany"
                  className="info-icon-w ms-2"
                  content={"Please select the company to update."}
                  maxWidth={100}
                  ariaLabel="Information: select company"
                />
              </div>
            </li>
            <li>
              <div className="mt-4">
                <div className="custom-input-wrapp">
                  <span className="floating-label mt-2">Company name</span>
                  <input
                    type="text"
                    value={companyData.name}
                    id="inputModifyCompanyName"
                    className="inputText"
                    required=""
                    tabIndex={1}
                    onChange={handleInputChange('name')}
                    disabled={editMode.name}
                  />
                  <div
                    className="right-actions edit-controls"
                    style={{ display: editForm ? 'block' : 'none' }}
                  >
                    {editMode.name ? (
                      <a className="editField" onClick={() => enableEditField('name')}>
                        <span className="bi bi-pencil" />
                      </a>
                    ) : (
                      <a
                        className="undoField"
                        onClick={() => undoField('name', selectedCompany?.name || '')}
                      >
                        <span className="bi bi-arrow-clockwise" />
                      </a>
                    )}
                  </div>
                  <span className="required-field-op">(Required)</span>
                </div>
              </div>
            </li>
            {/*SELECT COUNTRY CODE*/}
            <li className="select-drop-message">
              <div className="contact-num-wrap mt-3 row">
                <div className="country-code-w col-5">
                  <Form.Select
                    value={companyData.countryCode}
                    style={{ width: '100%' }}
                    onChange={handleInputChange('countryCode')}
                    disabled={editMode.countryCode}
                  >
                    <option value="">
                      Select Country Code
                    </option>

                    {countries && countries.map((countryCode) => (
                      <option
                        key={countryCode}
                        value={countryCode}
                        className="textdefault"
                      >
                        {en[countryCode]} ({countryCode})
                      </option>
                    ))}
                  </Form.Select>
                </div>
                <div className="col-2" style={{ display: editForm ? 'block' : 'none' }}>
                  {editMode.countryCode ? (
                    <a className="editField" onClick={() => enableEditField('countryCode')}>
                      <span className="bi bi-pencil" />
                    </a>
                  ) : (
                    <a
                      className="undoField"
                      onClick={() => undoField('countryCode', selectedCompany?.countryCode || '')}
                    >
                      <span className="bi bi-arrow-clockwise" />
                    </a>
                  )}
                </div>
              </div>
            </li>
            {/*SELECT REGISTRATION CODE*/}
            <li>
              <div className="edit-input-wrap mt-5">
                <div className="custom-input-wrapp">
                  <span className="floating-label">Registration Code</span>
                  <input
                    id="inputModifyRegistrationCode"
                    type="text"
                    className="inputText"
                    value={companyData.registrationCode}
                    required=""
                    tabIndex={1}
                    maxLength={32}
                    onChange={handleInputChange('registrationCode')}
                    disabled={editMode.registrationCode}
                  />
                  <div
                    className="right-actions edit-controls"
                    style={{ display: editForm ? 'block' : 'none' }}
                  >
                    {editMode.registrationCode ? (
                      <a className="editField" onClick={() => enableEditField('registrationCode')}>
                        <span className="bi bi-pencil" />
                      </a>
                    ) : (
                      <a
                        className="undoField"
                        onClick={() => undoField('registrationCode', selectedCompany?.registrationCode || '')}
                      >
                        <span className="bi bi-arrow-clockwise" />
                      </a>
                    )}
                  </div>
                  <span className="input-info-label ms-0">Eg: IN025852</span>
                  <span className="required-field-op ">(Required)</span>
                </div>
              </div>
            </li>
            {/*SELECT COMPANY DESCRIPTION*/}
            <li>
              <div className="custom-input-wrapp text-area-i mt-3">

                <textarea
                  id="textAreaModifyDescription"
                  className="cust-text-a"
                  maxLength={4000}
                  aria-multiline='true'
                  tabIndex={1}
                  placeholder="Description"
                  value={companyData.description}
                  onChange={handleInputChange('description')}
                  disabled={editMode.description}
                />


                <div
                  className="right-actions edit-controls"
                  style={{ display: editForm ? 'block' : 'none' }}
                >
                  {editMode.description ? (
                    <a className="editField" onClick={() => enableEditField('description')}>
                      <span className="bi bi-pencil" />
                    </a>
                  ) : (
                    <a
                      className="undoField"
                      onClick={() => undoField('description', selectedCompany?.description || '')}
                    >
                      <span className="bi bi-arrow-clockwise" />
                    </a>
                  )}
                </div>
                <span className="required-field-op">(Required)</span>
              </div>
            </li>
            {/*SELECT ADDITIONAL DETAILS*/}
            <li>
              <div className="custom-input-wrapp mt-3 mb-3">
                <div className="dropdown-w-info">
                  <div className="width-full">
                    <textarea
                      className="cust-text-a"
                      maxLength={4000}
                      placeholder="Additional Details"
                      id="textAreaModifyAdditionalDetails"
                      tabIndex={1}
                      value={companyData.additionalDetails}
                      onChange={handleInputChange('additionalDetails')}
                      disabled={editMode.additionalDetails}
                    />
                    <span className="required-field-op">(Required)</span>
                  </div>
                  <InfoPopover
                    id="infoPopOverModifyAdditionalDetails"
                    content="Please provide reason for change and any additional information relevant to the registration process here."
                    ariaLabel="Additional details information"
                    placement="top"
                    className="info-icon-w pop-common-sel sr-pophover ms-2"
                  />
                </div>
              </div>
            </li>
          </ul>
        </div>
      </li>
      {/*SUBMIT BUTTON*/}
      <li className="apim-pop-button-w comm-button-wrap ser-req-btn">
        {canSubmit ? (
          <button
            className="comm-button-style primary btn-disable"
            id="btnSubmitModifyCompany"
            tabIndex={1}
            onClick={createSRQ}
          >
            Create
          </button>
        ) : (
          <button className="button comm-button-style primary btn-disable" id="btnSubmitRegisterCompany" tabIndex="1" disabled>
            {!isCreateSRQButtonActive ? <>Create</> : <>Creating Service Request..</>}
          </button>
        )}
        <button
          type="button"
          className="button comm-button-style secondary"
          onClick={handleCancel}
        >
          Cancel
        </button>
      </li>
      {/*MY VERTICALLY CENTERED MODAL*/}
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        responseMessage={responseMessage}
        onConfirm={onServiceRequestCreated}
      />
      {/* ✅ Using global ToastContainer from App.js - removed local instance */}
      {OtpModalOpen && <OtpInputModal ModalHeading={""} setOpenOtpModal={setOtpModalOpen} handleOtp={handleOtp} value={OtpDataFromModal} verifyOtp={verifyOtp} credentialRecord={""} otpInputModelOpenendForAction={otpAction} resendOtp={resendOtp} />}
    </>
  );
}
export default ModiFyRegistrationDetails;